import React, { useState } from "react";

import {
  ChevronUp,
  ChevronDown
} from "react-feather";

export default function Box(props) {
  const [open, setOpen] = useState(props.defaultOpen);

  const content = open
    ? "box-content box__content--open"
    : "box-content";

  const icon = open
    ? <ChevronUp />
    : <ChevronDown />;

  return (
    <div className="box">
      <div className="box-header">
        <span className="box-title">{props.title}</span>

        <div>
          <button className="open__btn" onClick={props.onClick}>
            {props.icon}
          </button>

          <button className="open__btn ml-10" onClick={() => setOpen(!open)}>
            {icon}
          </button>
        </div>
      </div>

      <div className={content}>
        {props.children}
      </div>
    </div>
  );
}

Box.defaultProps = {
  defaultOpen: true
}